import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import ChatActions from '../actions/ChatActions';


const ChatSource = {

    getMessages() {
        return {
            remote(state, id) {
                let query = '';
                if (id.shift) {
                    query += '?hiring__shift__id=' + id.shift + (id.user ? '&hiring__candidate__user__id=' + id.user : '');
                }
                if (id.hiring) {
                    query += '?hiring__id=' + id.hiring;
                }

                return new SingleObjectResource(DJ_CONST.API.chatList + query).fetch();
            },

            success: ChatActions.getMessagesSuccess,
            error: CurrentUserActions.pageFault
        }
    },

    sendMessage() {
        return {
            remote(state, data) {
                return new SingleObjectResource(DJ_CONST.API.chatList).post(null, data);
            },

            success: ChatActions.getSendMessageSuccess,
            error: ChatActions.setSendMessageError
        };
    }
};

class ChatStore {
    constructor() {
        this.messages = {};
        this.sendMessageError = null;
        this.messageSent = false;

        this.exportAsync(ChatSource);
        this.bindActions(ChatActions);
    }

    onGetSendMessageSuccess() {
        this.setState({messageSent: true});
        setTimeout(x => {this.setState({messageSent: false})}, 5000);
    }

    onSetSendMessageError(sendMessageError) {
        this.setState({sendMessageError, messageSent: true});
    }

    onClearMessageSent() {
        this.setState({messageSent: false});
    }

    onGetMessagesSuccess(messages) {
        this.setState({messages})
    }
}

export default createStore(ChatStore, 'ChatStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/ChatStore.js
 **/